import React from "react";

/**
 * MergeProgress — shown while a merge is dispatched and polling. Deliberately a
 * spinner plus elapsed seconds, not a progress bar: the server gives no percent
 * of completion, so a bar would be a fabricated animation.
 */
function MergeProgress({ seconds }) {
  return (
    <div className="text-center py-5" data-testid="merge-progress">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Merging…</span>
      </div>
      <p className="mt-3 text-muted" data-testid="merge-progress-label">
        Merging… ({seconds}s)
      </p>
    </div>
  );
}

export default MergeProgress;
